import { Box, Typography, useMediaQuery } from '@mui/material';
import { useMemo, useState } from 'react';

import { HORIZONTAL_MAX_ITEM } from 'config';
import { MenuOrientation } from 'config';
import NavGroup from './NavGroup';
import _ from 'lodash';
import menuItem from 'menu-items';
import useConfig from 'hooks/useConfig';
import { useGetPermission } from 'hooks/queries/roles';
import { useSelector } from 'store';
import { useTheme } from '@mui/material/styles';

const Navigation = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('🚀 ~ Navigation ~ user:', user);
  const role_id = _.get(user, 'role_id');
  const getRolePerm = useGetPermission(role_id);

  const roleperms = useMemo(() => _.get(getRolePerm, 'data.menus', []), [getRolePerm]);
  console.log('🚀 ~ Navigation ~ roleperms:', roleperms);
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItems, setSelectedItems] = useState('');
  const [selectedLevel, setSelectedLevel] = useState(0);

  const filteredMenuItems = useMemo(() => {
    return {
      items: menuItem.items
        .map((group) => ({
          ...group,
          children: group.children?.filter((child) => !child.hidden && roleperms.includes(child.id))
        }))
        .filter((group) => group.children?.length > 0)
    };
  }, [menuItem.items, roleperms]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;
  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;

  let lastItemIndex = filteredMenuItems.items.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < filteredMenuItems.items.length) {
    lastItemId = filteredMenuItems.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = filteredMenuItems.items.slice(lastItem - 1).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon
    }));
  }

  const navGroups = filteredMenuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case 'group':
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        '& > ul:first-of-type': { mt: 0 },
        display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
